import React, { useState } from "react";
import { Modal, Input, message, Spin } from "antd";
import { DeleteIcon, Pen } from "../../assets/images/icons";
import "./partners.scss";
import api from "../../context/api";
import PartnersImageUploader from "../imageUploader/PartnersImageUploader";

const PartnersCard = ({ data, handleRefetch }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [updatedName, setUpdatedName] = useState(data?.name);
  const [updatedImage, setUpdatedImage] = useState(data?.image_url);
  const [loading, setLoading] = useState(false);

  const removeBrand = async () => {
    setLoading(true);
    try {
      await api.delete(`/partner/${data?.id}`);
      message.success("Partner muvaffaqiyatli o'chirildi");
      handleRefetch();
    } catch (error) {
      console.error("Partner o'chirishda xatolik:", error);
      message.error(error.response?.data?.message || "Partner o'chirilmadi");
    } finally {
      setLoading(false);
      setIsModalOpen(false);
    }
  };

  const updateBrand = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("name", updatedName);
    
    if (updatedImage instanceof File || updatedImage instanceof Blob) {
      formData.append("image_url", updatedImage);
    } else if (typeof updatedImage === 'string') {
      formData.append("image_url", updatedImage);
    }

    try {
      await api.put(
        `/partner/${data?.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      message.success("Partner muvaffaqiyatli yangilandi");
      handleRefetch();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Yangilashda xatolik:", error);
      message.error(error.response?.data?.message || "Partner yangilanmadi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={loading} delay={0}>
        <div className="partners-card">
          <div className="card-img">
            <img 
              src={data?.image_url} 
              alt={data?.name}
              style={{ width: '100%', height: '200px', objectFit: 'contain' }}
            />
            <div className="card-edit">
              <button onClick={() => { setIsEditMode(true); setIsModalOpen(true); }}>
                <Pen />
                O'zgartirish
              </button>
              <button onClick={() => { setIsEditMode(false); setIsModalOpen(true); }}>
                <DeleteIcon />
                O'chirish
              </button>
            </div>
          </div>
          <div className="card-text">
            <h1>{data?.name}</h1>
            <p>{new Date(data?.created_at).toLocaleDateString()}</p>
          </div>
        </div>
      </Spin>

      <Modal
        title={isEditMode ? "Partnerni o'zgartirish" : "Partnerni o'chirish"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <Spin spinning={loading}>
          {isEditMode ? (
            <div className="product_edit_card">
              <p className="product_edit_card_info"></p>
              <div style={{ marginBottom: '16px' }}>
                <img 
                  src={typeof updatedImage === 'string' ? updatedImage : URL.createObjectURL(updatedImage)} 
                  alt="Current" 
                  style={{ maxWidth: '100%', maxHeight: '200px' }}
                />
              </div>
              <PartnersImageUploader
                image_url={updatedImage}
                setImageUrl={setUpdatedImage}
              />
              <label htmlFor="name" className="product_edit_card_title">
                Nomi
                <Input
                  id="name"
                  value={updatedName}
                  onChange={(e) => setUpdatedName(e.target.value)}
                  style={{ marginBottom: "16px" }}
                  required
                />
              </label>
              <div className="modal-footer">
                <button onClick={() => setIsModalOpen(false)}>
                  Bekor qilish
                </button>
                <button style={{color:"white"}} onClick={updateBrand}>Saqlash</button>
              </div>
            </div>
          ) : (
            <div>
              <p>Siz rostdan ham ushbu brandni o'chirmoqchimisiz?</p>
              <div className="modal-footer">
                <button onClick={() => setIsModalOpen(false)}>
                  Bekor qilish
                </button>
                <button style={{color:"white"}} className="delete-btn" onClick={removeBrand}>
                  O'chirish
                </button>
              </div>
            </div>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default PartnersCard;